import { render, staticRenderFns } from "./shadows.vue?vue&type=template&id=b4f8d956&scoped=true&lang=pug&"
import script from "./shadows.vue?vue&type=script&lang=js&"
export * from "./shadows.vue?vue&type=script&lang=js&"
import style0 from "./shadows.vue?vue&type=style&index=0&id=b4f8d956&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f8d956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b4f8d956', component.options)
    } else {
      api.reload('b4f8d956', component.options)
    }
    module.hot.accept("./shadows.vue?vue&type=template&id=b4f8d956&scoped=true&lang=pug&", function () {
      api.rerender('b4f8d956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/shadows.vue"
export default component.exports